import React, { useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "../../web/stylesheets/components/Reports/HoldingReports/StockDetails.scss";
var GenericSidebar = function (props) {
    // const headerRef = useRef<HTMLDivElement>();
    // const footerRef = useRef<HTMLDivElement>();
    // const calculateViewBodyHeight = () => {
    //   const headerHeight = headerRef.current?.offsetHeight || 0;
    //   const footerHeight = footerRef.current?.offsetHeight || 0;
    //   document.documentElement.style.setProperty(
    //     "--generic-sidebar-headFooter-height",
    //     `${headerHeight + footerHeight}px` //70(footer)+40(clientdata) height (bodyHeight = 100vh - (headerHeight + footerHeight+) )
    //   );
    // };
    // useEffect(() => {
    //   let timer: ReturnType<typeof setTimeout> | undefined;
    // if (props.openKey === true) {
    //   timer = setTimeout(() => {
    //     calculateViewBodyHeight();
    //   }, 50);
    // }
    // return () => {
    //   if (timer) clearTimeout(timer);
    // };
    // }, [props.openKey, props.footer]);
    useEffect(function () {
        if (!props.enableBodyScroll) {
            var body = document.querySelector("body");
            body.style.overflow = props.openKey ? "hidden" : "auto";
        }
    }, [props.openKey]);
    var hideDetailSection = function (val) {
        if (!val) {
            document
                .getElementsByClassName("Marketstock-details-block")[0]
                .classList.add("hideDetailSection");
            setTimeout(function () {
                props.setOpenKey(false);
            }, props.delay ? props.delay : 700);
            (props === null || props === void 0 ? void 0 : props.onSideBarClose) && props.onSideBarClose();
        }
    };
    return (React.createElement(SlidingPane, { hideHeader: true, overlayClassName: "generic-sidebar-overlayblock ".concat(props.blurBackground ? "blur-background" : "no-blur"), className: "Marketstock-details-block", isOpen: props.openKey, from: "right", onRequestClose: function () { return hideDetailSection(props === null || props === void 0 ? void 0 : props.dontCloseOnOutsideClick); } },
        React.createElement("div", { className: "stock-details ".concat(props.parentClassname ? props.parentClassname : "") },
            props.header && (React.createElement("div", { className: "stock-details-head" },
                props.arrowClose && (React.createElement("div", { className: "stock-details-switch-key", onClick: function () { return hideDetailSection(false); } },
                    React.createElement("i", { className: !!(props === null || props === void 0 ? void 0 : props.parentIcon)
                            ? props === null || props === void 0 ? void 0 : props.parentIcon
                            : "edel-icon-cross-bold-small" }))),
                props.header)),
            props.body && React.createElement("div", { className: "stock-details-body" }, props.body),
            props.footer && (React.createElement("div", { className: "stock-details-footer" }, props.footer)))));
};
export default GenericSidebar;
